define( function() {
	return window.location;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/ajax/var/location.js
 ** module id = 886
 ** module chunks = 2
 **/